module.exports = __webpack_public_path__ + "img/0-4.f9fb6d9b.png";